import React from 'react'
import styles from './Gleam.scss'

export const Gleam = ({children}) => (
  <div className={styles.Gleam}>
    <span className={styles.content}>{children}</span>
  </div>
)
